// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"351":"ac8470db52a02c36bd81","678":"a7f3fe603cffe510dcb8","682":"87745d11f24c5c364603"}[chunkId] + ".js";
};